module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "progress"
  }, _vm._l((_vm.result), function(ref, index) {
    var confirmationUrl = ref.confirmationUrl;
    var dateFinish = ref.dateFinish;
    var result = ref.result;
    var title = ref.title;
    var student_fio = ref.student_fio;

    return _c('li', {
      key: index,
      staticClass: "progress__item"
    }, [_c('div', {
      staticClass: "progress__item-image"
    }, [_c('Icons', {
      attrs: {
        "type": result,
        "url": confirmationUrl
      }
    })], 1), _c('div', {
      staticClass: "progress__item-text"
    }, [_c('h3', {
      staticClass: "progress__name"
    }, [_vm._v(_vm._s(title))]), _c('p', {
      staticClass: "progress__name-student"
    }, [_c('span', {
      staticClass: "progress__thin"
    }, [_vm._v("Участник:")]), _c('strong', [_vm._v(_vm._s(student_fio))])]), _c('p', {
      staticClass: "progress__result"
    }, [_c('span', {
      staticClass: "progress__thin"
    }, [_vm._v("Результат:")]), _c('strong', [_vm._v(_vm._s(_vm.showProgress(result)))])]), _c('p', {
      staticClass: "progress__finish"
    }, [_c('span', {
      staticClass: "progress__thin"
    }, [_vm._v("Дата награждения:")]), _c('strong', [_vm._v(_vm._s(dateFinish))])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ce7b70","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/components/result/components/progress/Progress.vue
// module id = 2a35fcfd8fc6a982cc7d
// module chunks = 11